/**
 * Provider-agnostic failure of an access token request, so the token manager
 * can decide what to report without knowing the provider's error shapes.
 */
export class TokenRequestError extends Error {
  public constructor(
    public code: string,
    description: string,
    /**
     * Whether a session for the current configuration existed before the
     * request, i.e. the user was signed in rather than signed out.
     */
    public wasSignedIn: boolean,
    /**
     * Whether the session can no longer produce a token without the user
     * logging in again, as opposed to a transient failure (network, timeout).
     */
    public isTerminal: boolean,
    public details: Record<string, unknown> = {}
  ) {
    super(description === '' ? code : `${code}: ${description}`);
    Object.defineProperty(this, 'name', { value: 'TokenRequestError' });
  }
}
